import React, { useCallback, useState } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { disableOrEnableExaminingTeam } from '../../../services/exams/assessmentSession/assessments.service';
import { useLayoutContext } from '../../../Context/Layout.context';

export const DisableExaminingTeam: React.FC<{
  examiningTeamId: string;
  onSuccess: () => void;
  onFailure: () => void;
}> = (props) => {
  const [openSuccessPrompt, setOpenSuccessPrompt] = useState<boolean>(false);
  const [openFailurePrompt, setOpenFailurePrompt] = useState<boolean>(false);
  const [openConfirmationPrompt, setOpenConfirmationPrompt] = useState<boolean>(true);

  const { showLoader } = useLayoutContext();

  const disableSelectedExaminingTeam = useCallback(() => {
    showLoader(true);
    setOpenConfirmationPrompt(false);
    disableOrEnableExaminingTeam(props.examiningTeamId, true)
      .then(
        () => {
          setOpenSuccessPrompt(true);
        },
        () => {
          setOpenFailurePrompt(true);
        },
      )
      .finally(() => {
        showLoader(false);
      });
  }, [props.examiningTeamId]);


  const getPromptSubTexts = (isSuccess?: boolean) => {
    return [
      {
        text: isSuccess ? 'zakończone sukcesem.' : 'nie powiodło się, spróbuj ponownie później.',
        isBold: true,
      },
    ];
  };

  return (
    <>
      <Prompt
        type="confirmation"
        isBold={true}
        open={openConfirmationPrompt}
        mainText={'Czy na pewno chcesz zablokować Zespół Egzaminacyjny?'}
        subTexts={[
          {
            text: '(Zablokowanie Egzaminatora nie dotyczy pobranych lub ocenianych już rozwiąząń zadań)',
            isBold: true,
          },
        ]}
        onConfirm={disableSelectedExaminingTeam}
        onCancel={props.onFailure}
        mainActionButtonText="TAK"
      />
      <Prompt
        type="error"
        isBold={true}
        open={openFailurePrompt}
        mainText={'Zablokowanie Zespołu Egzaminacyjnego'}
        subTexts={getPromptSubTexts(false)}
        onConfirm={props.onFailure}
        mainActionButtonText="POWRÓT DO LISTY"
      />
      <Prompt
        type="success"
        isBold={true}
        open={openSuccessPrompt}
        mainText={'Zablokowanie Zespołu Egzaminacyjnego'}
        subTexts={getPromptSubTexts(true)}
        onConfirm={props.onSuccess}
        mainActionButtonText="POWRÓT DO LISTY"
      />
    </>
  );
};
